import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';
import { StmgService } from '../../../services/state_Management/stmg.service';
import { BettingServiceService } from '../../../services/betting_service/betting-service.service';

@Component({
  selector: 'app-in-play',
  templateUrl: './in-play.component.html',
  styleUrls: ['./in-play.component.scss'],
})
export class InPlayComponent implements OnInit {

  betCat: any = [];
  allCategories: any = [];
  sportIconList: any = [];
  selectedBetCategory: any;
  filter: number = 2;
  inplay: boolean = true;
  country: string = "";

  constructor(
    public renderer: Renderer2,
    public ele: ElementRef,
    private stmgService: StmgService,
    private bettingService: BettingServiceService
  ) { }

  ngOnInit() {

    // When refresh hide home page elements
    this.stmgService.setShowHomeElements(false);

    this.stmgService.cast_sportIcons.subscribe(sportIcons => this.sportIconList = sportIcons);

    this.stmgService.language_status.subscribe(message => {
      if(this.sportIconList != ""){
        this.bindSportIcons(this.sportIconList);
      }else{
        this.getSportIcons();
      }
    });

    //load new data when main nav bar clicked
    this.stmgService.inplayRefresh_status.subscribe(message =>{  
      if (this.sportIconList != "") {
        this.bindSportIcons(this.sportIconList);
      } else {
        this.getSportIcons();
      }
    });
  }


  bindSportIcons(data: any) {

    if (data != "") {
      for (let i = 0; i < data.length; i++) {
        this.allCategories[i] = {
          externalRef: data[i].externalRef,
          id: data[i].id,
          imageIcon: data[i].imageIcon.replace(/\s/g, ""), //remove spaces in base54 img
          sortOrder: data[i].sortOrder,
          sportCode: data[i].sportCode,
          sport_name: data[i].sport_name,
          status: data[i].status,
          active: false,
          filter: this.filter,
          inplay: this.inplay,
          country: this.country,
          showMatchWinner:data[i].showMatchWinner
        };
      }

      // get only MANUAL sports
      // ADDED " && element.sportCode != "MM" && element.sportCode != "GF" " TO TEMPORARY HIDE GOLF AND UFC FROM THE INPLAY BY **AKILA**
      let tempArry=[]
      this.allCategories.forEach(element => {
        if(element.externalRef!="MANUAL" && element.sportCode != "MM" && element.sportCode != "GF" && element.sportCode != "VB" && element.sportCode != "BT" && element.sportCode != "HB"){
          tempArry.push(element);
        }
      });
      
      this.allCategories=tempArry

      // select initial category 
      this.allCategories[0].active = true;
      this.selectedBetCategory = this.allCategories[0];
    }

  }

  // sport categories
  switch_SportCategories(item: any, event: any) {
    if(this.selectedBetCategory==item){
      this.stmgService.nav2inplayRefresh('yes');
    }else{
      this.selectedBetCategory = item;
      let myTag = this.ele.nativeElement.querySelectorAll("a");
      myTag.forEach(ele => {
        ele.classList.remove('active');
      })

      //set secondary nav bar active color
      if (event.target.id == "aTag") {
        this.renderer.addClass(event.target, 'active');
      } else {
        this.renderer.addClass(event.target.parentNode, 'active');
      }
    }

  }

  // get sport icons for initial load.
  getSportIcons() {
    this.bettingService.getSportIcons().subscribe(data => {
      this.bindSportIcons(data);
      this.updateSportIconsDataSTMG(data);

    })
  }

  updateSportIconsDataSTMG(d: any) {
    this.stmgService.updateSportIcons(d);
  }


}
